import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { EventTopperEntry } from "frontend/contentful/schema/toppers";
import { createCtaLinkProps } from "../primitives/cta-link.props";
import { EventTopperProps } from "design-system/components/toppers/event-topper/event-topper";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { useContentful } from "frontend/hooks/use-contentful";

export const createEventTopperProps = createContentfulProps<
  EventTopperEntry,
  EventTopperProps
>(({ entry }) => {
  const { getEntry } = useContentful();

  const eventEntry = getEntry(entry.fields.event);
  if (!eventEntry?.fields?.title) return undefined;

  const dates = [eventEntry.fields.startTime, eventEntry.fields.endTime].filter(
    (date): date is string => Boolean(date),
  );

  const description = eventEntry.fields.description
    ? RenderContentfulRichText({ document: eventEntry.fields.description })
    : undefined;

  return {
    title: eventEntry.fields.title,
    subtitle: description ?? undefined,
    dates,
    location: eventEntry.fields.location
      ? {
          title: eventEntry.fields.location
            ?.map((locationRef) => getEntry(locationRef)?.fields.title)
            .join(", "),
        }
      : undefined,
    cta: entry.fields.cta ? createCtaLinkProps(entry.fields.cta) : undefined,
    theme: entry.fields.theme,
  };
});
